import type { DateRange } from '@hotjar/global-filters';
import { DATE_UNITS, DATE_RANGE_TYPE } from '@hotjar/global-filters';
import { decodeDate, parseNumber, undelimit } from '../queryUtils';
import { ALL, FROM, TO, LAST } from './constants';

function parseDateUnit(value: string): DATE_UNITS | undefined {
  switch (value) {
    case 'hours':
      return DATE_UNITS.HOURS;
    case 'days':
      return DATE_UNITS.DAYS;
    case 'months':
      return DATE_UNITS.MONTHS;
  }

  return undefined;
}

export function parseDateRange(params: URLSearchParams): DateRange | undefined {
  const dateParam = params.get('date');
  if (dateParam === null) return undefined;

  const parts = undelimit(dateParam);

  switch (parts[0]) {
    case ALL:
      return { type: DATE_RANGE_TYPE.ALL };
    case FROM:
      if (parts.length !== 4 || parts[2] !== TO) return undefined;
      const from = decodeDate(parts[1]);
      const to = decodeDate(parts[3]);
      if (from === undefined || to === undefined) return undefined;
      return {
        type: DATE_RANGE_TYPE.ABSOLUTE,
        from,
        to,
      };
    case LAST:
      if (parts.length !== 3) return undefined;
      const amount = parseNumber(parts[1]);
      const unit = parseDateUnit(parts[2]);
      if (amount === undefined || unit === undefined) return undefined;
      return {
        type: DATE_RANGE_TYPE.RELATIVE,
        amount,
        unit,
      };
  }

  return undefined;
}
